var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_1",
    "data-name": "Subtra\\xE7\\xE3o 1",
    d: "M242-3529H229a5.006,5.006,0,0,1-5-5v-13a5.006,5.006,0,0,1,5-5h13a5.006,5.006,0,0,1,5,5v13A5.006,5.006,0,0,1,242-3529Zm-8.8-11.5v8.222h3.65v-8.222h2.434l.329-2.828h-2.762v-1.415c0-.714.059-1.151,1.217-1.151h1.513v-2.828h-2.434c-2.692,0-3.946,1.17-3.946,3.684v1.71h-1.809v2.828Z",
    transform: "translate(-224 3552)",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.02cf5cb3fcb4e8ad3eadccd20c56b8f8.svg";
export { ForwardRef as ReactComponent };